<div class="search_logo_container">
  <div class="search_icon br_50 flex_center_align_center"
       *ngIf="dataForShowIconsAndActions.showLeftSearch"
  >
    <img src="assets/images/icons/navbar/search.svg" class="pointer"
         (click)="openOrCloseSearchComponent(true)">
  </div>

  <div class="navigate_back flex_align_center"
       *ngIf="dataForShowIconsAndActions.showBack"
       (click)="backButtonClick()"
  >
    <img src="assets/images/mobile_icons/navigate-back_icon.svg">
  </div>

  <div class="pointer center" *ngIf="!dataForShowIconsAndActions.showAddress">
    <img src="assets/images/mobile_icons/logo.svg" (click)="mainPage()"
    >
  </div>
  <app-bottom-navbar-for-address-selection
    class="center"
    *ngIf="dataForShowIconsAndActions.showAddress"
    [fromTop]="true"
    [selectedData]="selectedData"
    (selectAddressToDeliverEvent)="selectAddressToDeliverEvent.emit($event)"
  ></app-bottom-navbar-for-address-selection>

  <div class="right">
    <div class="bonus_system pointer" (click)="openBonusInfoDialog()"
         *ngIf="dataForShowIconsAndActions.showBonus"
    >
      <div class="bonus_and_text flex_end_align_center br_24">
        <span class="text font_15 bold_800">
              {{(bonusAmount || 0) | priceSpaces}}
            </span>
        <img src="assets/images/icons/navbar/bonus_icon.svg">
      </div>
    </div>

    <div class="search_icon br_50 flex_center_align_center"
         *ngIf="dataForShowIconsAndActions.showFavorite"
         (click)="toggleFavorite()"
    >
      <img [src]="'assets/images/icons/navbar/' + (favoriteValue ? 'favorite-active.svg' : 'favorite-inactive.svg')"  class="pointer">
    </div>

    <div class="search_icon br_50 flex_center_align_center"
         *ngIf="dataForShowIconsAndActions.showRightSearch"
    >
      <img src="assets/images/icons/navbar/search.svg" class="pointer"
           (click)="openOrCloseSearchComponent(true)">
    </div>
  </div>

</div>

<app-search-dialog *ngIf="open" ></app-search-dialog>
<app-mobile-address-selection
  *ngIf="showMobileAddressSelection"
  (confirmed)="mobileAddressConfirmed.emit($event)"
  (closed)="mobileAddressClosed.emit()"
></app-mobile-address-selection>
